import { IEquipment } from '@frontend/equipment/types';
import { IProduct } from '@frontend/product/types';
import { TransactionReturnReason } from '@frontend/transaction/types';
import { Dispatch, SetStateAction, useState } from 'react';

import { useScreen } from '../useScreen';

interface ViewProps {
    product?: IProduct;
    equipment?: IEquipment;
    selectedReason?: TransactionReturnReason;
    setSelectedReason: Dispatch<SetStateAction<TransactionReturnReason | undefined>>;
    isProcessing: boolean;
    stopProcessing: () => void;
    handleSubmit: () => void;
}

const useWearableReturnReason = (): ViewProps => {
    const { updateWizardData, onSubmit, wizardData } = useScreen();
    const { product, equipment } = wizardData;
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [selectedReason, setSelectedReason] = useState<TransactionReturnReason | undefined>(undefined);

    const handleSubmit = () => {
        if (!selectedReason) return;
        setIsProcessing(true);
        updateWizardData({
            returnReason: selectedReason.value
        });
        onSubmit();
        setIsProcessing(false);
    };
    return {
        product,
        equipment,
        selectedReason,
        setSelectedReason,
        isProcessing,
        stopProcessing: () => setIsProcessing(false),
        handleSubmit
    };
};

export default useWearableReturnReason;
